import EvaluateResponse from "../../EvaluateResponse"
import Evaluation from "../../Evaluation"
import { EvaluatorContext } from "../../evaluator/Evaluator"
import Workspace from "../../../workspace/Workspace"
import { HackleUser } from "../../../model/model"
import ExperimentEvaluation from "../../service/experiment/ExperimentEvaluation"
import { ExperimentEvaluateResult } from "../../service/experiment/ExperimentEvaluateResult"
import ExperimentEvaluateRequest from "./ExperimentEvaluateRequest"

export default class ExperimentEvaluateResponse implements EvaluateResponse {
  constructor(
    readonly user: HackleUser,
    readonly workspace: Workspace,
    readonly evaluation: ExperimentEvaluation,
    readonly references: Evaluation[]
  ) {}

  static of(
    request: ExperimentEvaluateRequest,
    context: EvaluatorContext,
    result: ExperimentEvaluateResult
  ): ExperimentEvaluateResponse {
    return new ExperimentEvaluateResponse(
      request.user,
      request.workspace,
      new ExperimentEvaluation(request.entity, result),
      context.references
    )
  }
}
